export const LANGUAGE = {
  EN: 'en',
  ES: 'es',
} as const

export const SERVER_LANGUAGE_MAP = {
  English: LANGUAGE.EN,
  Spanish: LANGUAGE.ES,
} as const

export const LANGUAGE_STORAGE_KEY = 'app_language'
